/**
 * Provides requestAnimationFrame in a cross browser way.
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 */

if (!window.requestAnimationFrame) {

    window.requestAnimationFrame = function () {

        return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function ( /* function FrameRequestCallback */callback, /* DOMElement Element */element) {

            window.setTimeout(callback, 1000 / 60);
        };
    }();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/pannellum-react-vc/es/pannellum/js/RequestAnimationFrame.js
// module id = ./node_modules/pannellum-react-vc/es/pannellum/js/RequestAnimationFrame.js
// module chunks = 0